export default function (editor) {
  const blockManager = editor.BlockManager

  blockManager.add('Image', {
    id: 'image',
    category: 'Components',
    label: 'Image',
    // Select the component once it's dropped
    select: true,
    // You can pass components as a JSON instead of a simple HTML string,
    // in this case we also use a defined component type `image`
    attributes: { class: 'gjs-fonts gjs-f-image' },
    content: { type: 'image' },
    // This triggers `active` event on dropped components and the `image`
    // reacts by opening the AssetManager
    activate: true
  })

  blockManager.add('text', {
    label: 'Text',
    category: 'Components',
    attributes: { class: 'gjs-fonts gjs-f-text' },
    content: {
      type: 'text',
      content: 'Insert your text here',
      classes: 'q-pa-sm',
      activeOnRender: true
    }
  })

  blockManager.add('link', {
    label: 'Link',
    category: 'Components',
    attributes: { class: 'fa fa-link' },
    content: {
      type: 'link',
      content: 'Link'
    }
  })

  const buttonContent =
    `<a href="/"
      class="q-btn non-selectable no-outline q-btn--unelevated q-btn--rectangle bg-primary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active"><span
        class="q-focus-helper"></span><span class="q-btn__wrapper col row q-anchor--skip"><span
          class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
          <span class="button-label" >
            Button Text
          </span>
        </span>
      </span>
    </a>`
  blockManager.add('button', {
    label: 'Button',
    category: 'Components',
    content: buttonContent
  })

  blockManager.add('video', {
    label: 'Video',
    category: 'Components',
    attributes: { class: 'fa fa-youtube-play' },
    content: {
      type: 'video',
      src: 'img/video2.webm',
      style: {
        height: '350px',
        width: '615px'
      }
    }
  })

  blockManager.add('map', {
    label: 'Map',
    category: 'Components',
    attributes: { class: 'fa fa-map-o' },
    content: {
      type: 'map',
      style: { height: '350px' }
    }
  })

  const contentHere = () => '<div>Content Here</div>'
  const renderContent = (content) => {
    if (Array.isArray(content)) {
      return content.join('')
    }

    return content || contentHere()
  }
  const gridRow = (content) => `<div data-gjs-type="grid-row" class="row justify-center items-center">${renderContent(content)}</div>`
  const gridColumnFull = (content) => `<div data-gjs-type="grid-column" class="col-12 q-pa-sm text-center">${renderContent(content)}</div>`
  const gridColumnTwoThird = (content) => `<div data-gjs-type="grid-column" class="col-sm-8 col-12 q-pa-sm text-center">${renderContent(content)}</div>`
  const gridColumnHalf = (content) => `<div data-gjs-type="grid-column" class="col-sm-6 col-12 q-pa-sm text-center">${renderContent(content)}</div>`
  const gridColumnThird = (content) => `<div data-gjs-type="grid-column" class="col-sm-4 col-12 q-pa-sm text-center">${renderContent(content)}</div>`
  const gridColumnQuarter = (content) => `<div data-gjs-type="grid-column" class="col-sm-3 col-12 q-pa-sm text-center">${renderContent(content)}</div>`

  blockManager.add('Grid Row', {
    id: 'q-row',
    category: 'Grid',
    label: 'Grid Row',
    attributes: { class: 'gjs-fonts gjs-f-b1' },
    content: gridRow(gridColumnFull())
  })
  blockManager.add('Grid Row 2', {
    id: 'q-row-2',
    category: 'Grid',
    label: 'Grid Row 2',
    attributes: { class: 'gjs-fonts gjs-f-b2' },
    content: gridRow([gridColumnHalf(), gridColumnHalf()])
  })
  blockManager.add('Grid Row 3', {
    id: 'q-row-3',
    category: 'Grid',
    label: 'Grid Row 3',
    attributes: { class: 'gjs-fonts gjs-f-b3' },
    content: gridRow([gridColumnThird(), gridColumnThird(), gridColumnThird()])
  })
  blockManager.add('Grid Row 4', {
    id: 'q-row-4',
    category: 'Grid',
    label: 'Grid Row 4',
    attributes: { class: 'gjs-fonts gjs-f-b3' },
    content: gridRow([gridColumnQuarter(), gridColumnQuarter(), gridColumnQuarter(), gridColumnQuarter()])
  })
  blockManager.add('Grid Row 1/2', {
    id: 'q-row-4',
    category: 'Grid',
    label: 'Grid Row 1/2',
    attributes: { class: 'gjs-fonts gjs-f-b37' },
    content: gridRow([gridColumnThird(), gridColumnTwoThird()])
  })
  blockManager.add('Grid Row 2/1', {
    id: 'q-row-4',
    category: 'Grid',
    label: 'Grid Row 2/1',
    attributes: { class: 'gjs-fonts gjs-f-b37' },
    content: gridRow([gridColumnTwoThird(), gridColumnThird()])
  })

  blockManager.add('Cell Full Width', {
    id: 'col-12',
    category: 'Grid',
    label: 'Cell Full Width',
    attributes: { class: 'gjs-fonts gjs-f-b1' },
    content: gridColumnFull()
  })
  blockManager.add('Cell 1/2 Width', {
    id: 'col-12',
    category: 'Grid',
    label: 'Cell 1/2 Width',
    attributes: { class: 'gjs-fonts gjs-f-b2' },
    content: gridColumnHalf()
  })
  blockManager.add('Cell 1/3 Width', {
    id: 'col-12',
    category: 'Grid',
    label: 'Cell 1/3 Width',
    attributes: { class: 'gjs-fonts gjs-f-b3' },
    content: gridColumnThird()
  })
  blockManager.add('Cell 1/4 Width', {
    id: 'col-12',
    category: 'Grid',
    label: 'Cell 1/4 Width',
    attributes: { class: 'gjs-fonts gjs-f-b3' },
    content: gridColumnQuarter()
  })
}
